// Traducciones para la página de pago
import { Language } from '../types';

const translations = {
  en: {
    needHelp: 'Need help?',
    callUs: 'Call us at',
    whatsapp: 'Whatsapp',
    enterYourData: 'Enter your information',
    contactData: 'Contact Information',
    name: 'Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone Number',
    paymentMethod: 'Payment Method Details',
    country: 'Country',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    address: 'Address',
    purchaseSummary: 'Purchase Summary',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    rooms: 'Rooms',
    guests: 'Guests',
    total: 'Total',
    bookingNumber: 'Booking #',
    reference: 'Reference',
    currencyConversion: 'Currency conversion',
    bestPriceGuaranteed: 'Best price guaranteed',
    pricePledge: 'If you find a better price on another website for the same stay, we will match it.',
    secureTransactions: 'Your purchases are secure',
    requireInvoice: 'I require an invoice',
    billingInformation: 'Billing Information',
    companyName: 'Company Name',
    taxStatus: 'Tax Status',
    invoiceUsage: 'Invoice Usage',
    billingEmail: 'Billing Email',
    street: 'Street',
    externalNumber: 'External Number',
    internalNumber: 'Internal Number',
    neighborhood: 'Neighborhood',
    municipality: 'Municipality',
    processing: 'Processing',
    paymentSuccess: 'Payment Successful',
    paymentError: 'Payment Issue',
    payText: 'Pay',
    processingText: 'Processing...',
    successPayment: 'Payment Successful!',
    successMessage: 'Your payment has been processed successfully. Thank you!',
    redirecting: 'Redirecting...',
    errorPayment: 'Payment Issue',
    errorReferenceAlreadyUsed: 'This reference has already been used. Please contact the hotel for assistance.',
    loadingPaymentDetails: 'Loading payment details...',
    language: 'Language',
    selectLanguage: 'Select language',
    accept: 'I accept the',
    privacyPolicy: 'privacy policy',
    termsAndConditions: 'terms and conditions',
    and: 'and',
    mustAcceptPolicies: 'You must accept the privacy policy and/or terms and conditions to proceed.',
    pay: 'Pay',
    initializingPaymentForm: 'Initializing payment form...',
    bookingSummary: 'Booking Summary',
    items: 'Items',
    confirmationCode: 'Confirmation Code',
    copy: 'Copy',
    copied: 'Copied!',
    saveCodeHelp: 'Save this code to reference your payment when contacting support.'
  },
  es: {
    needHelp: '¿Necesitas ayuda?',
    callUs: 'Llámanos al',
    whatsapp: 'Whatsapp',
    enterYourData: 'Ingresa tus Datos',
    contactData: 'Datos de Contacto',
    name: 'Nombre',
    lastName: 'Apellidos',
    email: 'Correo electrónico',
    phone: 'Número telefónico',
    paymentMethod: 'Datos del Método de Pago',
    country: 'País',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código Postal',
    address: 'Dirección',
    purchaseSummary: 'Resumen de tu compra',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    rooms: 'Habitaciones',
    guests: 'Huéspedes',
    total: 'Total',
    bookingNumber: 'Reserva #',
    reference: 'Referencia',
    currencyConversion: 'Conversión de moneda',
    bestPriceGuaranteed: 'Mejor precio garantizado',
    pricePledge: 'Si encuentras un mejor precio en otra página web para la misma estancia, te lo igualamos.',
    secureTransactions: 'Tus compras son seguras',
    requireInvoice: 'Requiero factura',
    billingInformation: 'Información de facturación',
    companyName: 'Razón Social',
    taxStatus: 'Situación Fiscal',
    invoiceUsage: 'Uso de Factura',
    billingEmail: 'Email para facturación',
    street: 'Calle',
    externalNumber: 'Número Exterior',
    internalNumber: 'Número Interior',
    neighborhood: 'Colonia',
    municipality: 'Municipio',
    processing: 'Procesando',
    paymentSuccess: 'Pago Exitoso',
    paymentError: 'Problema con el Pago',
    payText: 'Pagar',
    processingText: 'Procesando...',
    successPayment: '¡Pago exitoso!',
    successMessage: 'Tu pago se ha realizado correctamente. ¡Gracias!',
    redirecting: 'Redirigiendo...',
    errorPayment: 'Problema con el Pago',
    errorReferenceAlreadyUsed: 'Esta referencia ya ha sido utilizada. Por favor contacta al hotel para recibir asistencia.',
    loadingPaymentDetails: 'Cargando detalles de pago...',
    language: 'Idioma',
    selectLanguage: 'Seleccionar idioma',
    accept: 'Acepto la',
    privacyPolicy: 'política de privacidad',
    termsAndConditions: 'términos y condiciones',
    and: 'y',
    mustAcceptPolicies: 'Debes aceptar la política de privacidad y/o términos y condiciones para continuar.',
    pay: 'Pagar',
    initializingPaymentForm: 'Inicializando formulario de pago...',
    bookingSummary: 'Resumen de la reserva',
    items: 'Elementos',
    confirmationCode: 'Código de Confirmación',
    copy: 'Copiar',
    copied: '¡Copiado!',
    saveCodeHelp: 'Guarda este código para referenciar tu pago al contactar soporte.'
  },
  fr: {
    needHelp: 'Besoin d\'aide?',
    callUs: 'Appelez-nous au',
    whatsapp: 'Whatsapp',
    enterYourData: 'Entrez vos informations',
    contactData: 'Informations de contact',
    name: 'Prénom',
    lastName: 'Nom de famille',
    email: 'Email',
    phone: 'Numéro de téléphone',
    paymentMethod: 'Détails du mode de paiement',
    country: 'Pays',
    city: 'Ville',
    state: 'État',
    postalCode: 'Code postal',
    address: 'Adresse',
    purchaseSummary: 'Résumé de l\'achat',
    checkIn: 'Arrivée',
    checkOut: 'Départ',
    rooms: 'Chambres',
    guests: 'Invités',
    total: 'Total',
    bookingNumber: 'Réservation #',
    reference: 'Référence',
    currencyConversion: 'Conversion de devises',
    bestPriceGuaranteed: 'Meilleur prix garanti',
    pricePledge: 'Si vous trouvez un meilleur prix sur un autre site web pour le même séjour, nous l\'égalerons.',
    secureTransactions: 'Vos achats sont sécurisés',
    requireInvoice: 'Je demande une facture',
    billingInformation: 'Informations de facturation',
    companyName: 'Nom de la société',
    taxStatus: 'Statut fiscal',
    invoiceUsage: 'Utilisation de la facture',
    billingEmail: 'Email de facturation',
    street: 'Rue',
    externalNumber: 'Numéro extérieur',
    internalNumber: 'Numéro intérieur',
    neighborhood: 'Quartier',
    municipality: 'Municipalité',
    processing: 'Traitement',
    paymentSuccess: 'Paiement réussi',
    paymentError: 'Problème de paiement',
    payText: 'Payer',
    processingText: 'Traitement en cours...',
    successPayment: 'Paiement réussi!',
    successMessage: 'Votre paiement a été traité avec succès. Merci!',
    redirecting: 'Redirection...',
    errorPayment: 'Problème de paiement',
    errorReferenceAlreadyUsed: 'Cette référence a déjà été utilisée. Veuillez contacter l\'hôtel pour obtenir de l\'aide.',
    loadingPaymentDetails: 'Chargement des détails de paiement...',
    language: 'Langue',
    selectLanguage: 'Choisir la langue',
    accept: 'J\'accepte la',
    privacyPolicy: 'politique de confidentialité',
    termsAndConditions: 'conditions générales',
    and: 'et',
    mustAcceptPolicies: 'Vous devez accepter la politique de confidentialité et/ou les conditions générales pour continuer.',
    pay: 'Payer',
    initializingPaymentForm: 'Initialisation du formulaire de paiement...',
    bookingSummary: 'Résumé de la réservation',
    items: 'Articles',
    confirmationCode: 'Code de Confirmation',
    copy: 'Copier',
    copied: 'Copié!',
    saveCodeHelp: 'Enregistrez ce code pour référencer votre paiement lors du contact avec le support.'
  },
  pt: {
    needHelp: 'Precisa de ajuda?',
    callUs: 'Ligue para',
    whatsapp: 'Whatsapp',
    enterYourData: 'Insira suas informações',
    contactData: 'Informações de contato',
    name: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Número de telefone',
    paymentMethod: 'Detalhes do método de pagamento',
    country: 'País',
    city: 'Cidade',
    state: 'Estado',
    postalCode: 'Código postal',
    address: 'Endereço',
    purchaseSummary: 'Resumo da compra',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    rooms: 'Quartos',
    guests: 'Hóspedes',
    total: 'Total',
    bookingNumber: 'Reserva #',
    reference: 'Referência',
    currencyConversion: 'Conversão de moeda',
    bestPriceGuaranteed: 'Melhor preço garantido',
    pricePledge: 'Se você encontrar um preço melhor em outro site para a mesma estadia, nós igualaremos.',
    secureTransactions: 'Suas compras são seguras',
    requireInvoice: 'Preciso de nota fiscal',
    billingInformation: 'Informações de faturamento',
    companyName: 'Nome da empresa',
    taxStatus: 'Situação fiscal',
    invoiceUsage: 'Uso da nota fiscal',
    billingEmail: 'Email para faturamento',
    street: 'Rua',
    externalNumber: 'Número externo',
    internalNumber: 'Número interno',
    neighborhood: 'Bairro',
    municipality: 'Município',
    processing: 'Processando',
    paymentSuccess: 'Pagamento bem-sucedido',
    paymentError: 'Problema com o pagamento',
    payText: 'Pagar',
    processingText: 'Processando...',
    successPayment: 'Pagamento bem-sucedido!',
    successMessage: 'Seu pagamento foi processado com sucesso. Obrigado!',
    redirecting: 'Redirecionando...',
    errorPayment: 'Problema com o pagamento',
    errorReferenceAlreadyUsed: 'Esta referência já foi utilizada. Por favor, entre em contato com o hotel para obter ajuda.',
    loadingPaymentDetails: 'Carregando detalhes do pagamento...',
    language: 'Idioma',
    selectLanguage: 'Selecione o idioma',
    accept: 'Aceito a',
    privacyPolicy: 'política de privacidade',
    termsAndConditions: 'termos e condições',
    and: 'e',
    mustAcceptPolicies: 'Você deve aceitar a política de privacidade e/ou termos e condições para continuar.',
    pay: 'Pagar',
    initializingPaymentForm: 'Inicializando formulário de pagamento...',
    bookingSummary: 'Resumo da reserva',
    items: 'Itens',
    confirmationCode: 'Código de Confirmação',
    copy: 'Copiar',
    copied: 'Copiado!',
    saveCodeHelp: 'Salve este código para referenciar seu pagamento ao entrar em contato com o suporte.'
  }
};

// Define the type for one set of translations based on the 'en' property
type TranslationSet = typeof translations.en;

// Explicitly type the translations object for stricter checking.
const typedTranslations: Record<Language, TranslationSet> = translations;

// Helper function to get translated text
export const getTranslation = (key: keyof TranslationSet, lang: Language): string => {
  return typedTranslations[lang][key];
};

export default typedTranslations;
